import { useTranslation } from 'i18n';
import React from 'react';
import { Button } from 'ui';
import { useToggle } from '../../../disclosure/hooks/useToggle/useToggle';

import { SessionEvidenceEditDialog } from '../SessionEvidenceEditDialog/SessionEvidenceEditDialog';

export const SessionEditDialog = ({
  date,
  parentContentTypeId,
  parentId,
  uploadedById,
}: {
  date: string;
  parentContentTypeId: number | null;
  parentId: number | null;
  uploadedById: number | null;
}) => {
  const { t } = useTranslation('features');
  const { open, isOpen, close } = useToggle();

  return (
    <div>
      <Button onClick={open} disabled={!parentContentTypeId || !parentId}>
        {t('backlog.evidence.sessionEditDialog.actions.editDeleteEvidence')}
      </Button>
      {parentContentTypeId && parentId ? (
        <SessionEvidenceEditDialog
          date={date}
          parentContentTypeId={parentContentTypeId}
          parentId={parentId}
          uploadedById={uploadedById}
          open={isOpen}
          onClose={close}
        />
      ) : null}
    </div>
  );
};
